export default __webpack_public_path__ + "static/media/Background_00207.9bb91cc2.png";